import CaretBottomIcon from 'assets/icons/landing/caret-bottom'
import { Qna } from 'components/views/Landing/section-faq.view'
import { useState } from 'react'
import { Collapse } from 'react-collapse'

export default function FaqItem({ question, answer }: Qna): JSX.Element {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      onClick={() => setIsOpen(!isOpen)}
      className={`rounded-[20px] lg:rounded-xl cursor-pointer p-4 lg:p-8 mb-4 lg:mb-3 w-full ${
        isOpen ? 'bg-[var(--bg-faq-active)]' : 'bg-[var(--bg-faq)]'
      }`}
    >
      <div
        className={`w-full flex items-center justify-between gap-3 ${
          isOpen && 'mb-5'
        } transition-all duration-300 ease-in ${
          isOpen ? 'text-[var(--text-landing-green)]' : 'text-[var(--text-step-card-body)]'
        } `}
      >
        <h3
          className={`${isOpen ? 'font-bold' : 'font-medium'} text-left text-md sm:text-[24px] sm:leading-[140%] pr-3`}
        >
          {question}
        </h3>
        <div className={`shrink-0 transition-transfom  duration-150 ${isOpen && 'rotate-180'}`}>
          <CaretBottomIcon />
        </div>
      </div>
      <Collapse isOpened={isOpen}>
        <div className={`lg:text-base text-[14px] text-main text-start `}>{answer}</div>
      </Collapse>
    </div>
  )
}
